import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcesses(organization_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/list_processes/${organization_id}/fetch_agro_exporter_processes`
    );
  },
  
}
